import type { SearchData } from '@ltvco/refresh-lib/v1';

export const PROPERTY_REPORT_MAP_FEATURE_KEY = 'UPS-1269';

export const PROPERTY_REPORT_MAP_ROUTE = '/report/property/map';

/**
 * Builds a property report URL from a permalink (and optional search params).
 * Used only for a fresh property address search — not recent-report or
 * dashboard shortcuts, which must open `/report/property` via viewReportUrl.
 */
export const buildPropertyReportUrl = (
  permalink: string,
  isPropertyReportMapEnabled: boolean,
  searchParams?: string
): string => {
  const queryString = searchParams
    ? `${searchParams}&permalink=${permalink}`
    : `permalink=${permalink}`;

  if (isPropertyReportMapEnabled) {
    return `${PROPERTY_REPORT_MAP_ROUTE}?${queryString}`;
  }

  return `/report/property?${queryString}`;
};

/**
 * Builds the post-search destination URL for all report types.
 * Only a fresh property address search routes to the map when the flag is on.
 */
export const buildSearchSuccessUrl = (
  { reportType, searchParams, permalink }: SearchData,
  isPropertyReportMapEnabled: boolean
): string => {
  if (reportType === 'property') {
    return buildPropertyReportUrl(
      permalink,
      isPropertyReportMapEnabled,
      searchParams
    );
  }

  const queryString = `${searchParams}&permalink=${permalink}`;

  return `/report/${reportType}?${queryString}`;
};
